import PageDetail from "../abstract/PageDetail.js";
import { SecurityAcl, SecurityAclContext, AuthCheckAcl } from "../../Security.js";
import { ModalConfirm, ModalAlert } from "../../su/Modals.js";
import GridWrapper from "../../su/GridWrapper.js";

export default class PageMobileDetail extends PageDetail {
	constructor() {
		super();
	}

	init($data) {
		super.init($data);
		console.log($data);

		if (this.aclContext.HasGrantedAcl(new AuthCheckAcl(this.data.rowSUid, SecurityAcl.ACL_DELETE))) {
			$(".jsBtnRemove").on("click", this.onDelete.bind(this))
		} else {
			$(".jsBtnRemove").remove();
		}

		this.initGridList();

	}

	initGridList() {
		// h
		let h = this.getAvailableHeight();
		//
		this.theGrid = new GridWrapper($(".jsList"));

		let options = {
			dataSource: {
				// data: $data.rows,
			},
			sorting: {
				multiple: false,
				allowUnsort: false
			},
			paging: {
				pageSize: 12,
				pageLinksCount: 10
			},
			rowHover: false,
			altRows: false,
			selection: {
				type: "row",
				multiple: false,
				toggle: false,
			},
			columns: [
				{
					field: "PrivacyVersion",
					title: "Privacy Version"
				},
				{
					field: "Privacy0",
					title: "Privacy0"
				},
				{
					field: "Privacy1",
					title: "Privacy1"
				},
				{
					field: "Privacy2",
					title: "Privacy2"
				},
				{
					field: "Privacy3",
					title: "Privacy3"
				},
				{
					field: "Privacy4",
					title: "Privacy4"
				},
				{
					field: "RecordDtUpdate",
					title: "Data Modifica"
				},
			],
			events: {
/*				selectionChanged: this.openDetailPage.bind(this)*/
			},
			scrolling: true,
			resizing: true,
			height: h + "px"
		}

		this.theGrid.create(options, this.data.rows);
		//this.theGrid.enableSearch($(".jsListSearchLastEdit"), {
		//	or: [
		//		{ path: "Type", filter: "contains", value: "" },
		//		{ path: "EntityType", filter: "contains", value: "" },
		//		{ path: "EntityLabel", filter: "contains", value: "" },
		//		{ path: "LastEditedBy", filter: "contains", value: "" },
		//		{ path: "LastEditedDateForSearch", filter: "contains", value: "" },
		//	]
		//});
		this.theGrid.init("jsList");
		// var a = StateManager.getViewState("jsList")
		jQuery(window).on("resize.grid", this.onResize.bind(this));

		return;
	}

	handleErrors(rs) {
		// Overridata per gestire in modo custom gli errori non legati ai singoli campi ma più generali (il messaggio compare in una modal)

		if (rs.StatusCode === 401) {
			return "You do not have permission for this action to complete!"
		}
		if (rs.StatusCode === 412) {
			return "You cannot put this in draft because this item is linked elsewhere!"
		}

		return PageMobileDetail.GENERIC_SAVE_ERROR; //500
	}

	getFieldErrorReturnedByServer(rs, code) {
		// Overridata per gestire in modo custom gli errori legati ai campi che arrivano dal server (il messaggio compare vicino al campo in questione)
		if (code === PageMobileDetail.ERROR_FIELD_CODE_NOT_UNIQUE) {
			return "This code has already been used (must be unique for every entry)";
		} else {
			let error = null;
			error = TheApp.Res[TheApp.Locale]["ERROR." + code];
			if (!error)
				error = TheApp.Res[TheApp.Locale][code];
			if (error)
				return error
        }
		return code;
	}


	onDelete(dataIndex) {
		let modal = new ModalConfirm($("#template-modalConfirm"));
		modal.create(
			{
				title: "Conferma cancellazione",
				body: "Sei sicuro di voler rimuovere definitivamente questo elemento? Non puoi annullare questa azione.",
				yes: "SI",
				no: "NO",
				danger: true // viene il pulsante rosso, altrimenti blue
			}, this.onConfirmDelete.bind(this));
		modal.init();
	}

	onConfirmDelete(bConfirm) {
		if (bConfirm) {
			this.showPreloader(true);
			let rq = {
				Value: this.data.row.Uid
			}
			thatServiceManeger.standardCall(this.data.serviceDeleteRoute, rq, this.onDeleteServiceHandler.bind(this));
		}
	}

	onDeleteServiceHandler(rs) {
		this.showPreloader(false);
		//
		if (rs.Success) {
			let args = StateManager._splitUrl(document.location.href);
			let url = "?_vs=" + encodeURIComponent(args.qPart["_vs"]) + "&__pi=" + this.data.page.PrevPageId
			document.location.href = TheApp.Env.BaseUrlNls + "users/" + url;

		} else {
			let error = null;
			if (rs.hasOwnProperty('Errors') && rs.Errors !== null && rs.Errors.length >= 0) {
				error = TheApp.Res[TheApp.Locale]["ERROR." + rs.Errors[0].Code];
				if (rs.Errors[0].RefsUid.length > 0) {
					error = error.replace("{0}", rs.Errors[0].RefsUid);
				}
			}
			if (!error)
				error = TheApp.Res[TheApp.Locale]["ERROR.HTTP." + rs.StatusCode];
			if (!error)
				error = TheApp.Res[TheApp.Locale]["ERROR.HTTP.DEFAULT"];
			//
			let modal = new ModalAlert($("#template-modalAlert"));
			modal.create(
				{
					title: "AN ERROR OCCURRED",
					body: error,
					close: "CLOSE",
					error: true
				});
			modal.init();
		}
	}

	getAvailableHeight() {
		let a = jQuery(".js-size");
		let i = 0;
		for (let x = 0; x < a.length; x++) {
			i += jQuery(a[x]).outerHeight();
		}
		i += 50; // padding app container
		i += 78; // search box
		i += 143; // paging
		let h = jQuery(window).height() - i;
		return h;
	}

	onResize(e) {
		//debugger;
		this.theGrid.setHeight(this.getAvailableHeight());
	}

}

PageMobileDetail.ERROR_FIELD_CODE_NOT_UNIQUE = "UniqueFieldConstraintFailed";

